"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parse = parse;
const uom_1 = require("@genesys/uom");
const freons = {
    R134: 0,
    R22: 1,
    R404A: 2,
    R407C: 3,
    R410A: 4
};
function parse(air) {
    const units = air.map(a => uom_1.Serialize.stringToUnit(a[2].substring(1, a[2].length - 1)));
    const parseAmount = (index) => {
        const unit = units[index];
        if (!unit) {
            throw new Error("Freon: Unknown unit at column index: " + index);
        }
        const value = parseFloat(air[index][1]);
        return uom_1.Serialize.amountToString(uom_1.Amount.create(value, unit));
    };
    const parseText = (index) => air[index][1];
    return {
        temperatureIn: parseAmount(0),
        humidityIn: parseAmount(1),
        pressureIn: parseAmount(2),
        freonState: {
            evaporationTemperature: parseAmount(3),
            condensingTemperature: parseAmount(4),
            subCooling: parseAmount(5),
            superHeat: parseAmount(6),
            freon: parseFreon(parseText(7))
        }
    };
}
function parseFreon(freon) {
    const fr = freons[freon.toUpperCase()];
    if (fr === undefined) {
        throw new Error("Unknown material");
    }
    return fr;
}
//# sourceMappingURL=parse-case-freon.js.map